import { useQuery } from '@tanstack/react-query';
import { workspaceApi } from '../../api';
import { queryKeys } from '../../queries/keys';

/**
 * Whether the SME agent workspace is switched on for this account.
 *
 * The workspace is behind a backend flag that is off by default, and when it is
 * off `/workspace` can only say so. Both entry points — Home's CTA and the
 * rail's nav item — ask this before offering the route, and they share one
 * cached answer rather than each issuing their own request.
 *
 * `undefined` while the answer is still in flight: neither call site should
 * disable a control on a guess.
 */
export default function useWorkspaceEnabled(): boolean | undefined {
  const { data, isPending, isError } = useQuery({
    queryKey: queryKeys.workspaceConfig(),
    queryFn: () => workspaceApi.getConfig(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  if (isPending) return undefined;
  /* A config that cannot be read is not proof the feature is off, so the route
     stays reachable and the page states the real problem. */
  if (isError) return true;
  return Boolean(data?.enabled);
}
